import React, { useState, useEffect, useRef } from 'react';
import { Input, Form, Spin, Button, DatePicker, Radio, InputNumber,Table, Popover } from 'antd';
import { useHistory } from 'react-router-dom';
import { InfoCircleOutlined, PrinterOutlined } from '@ant-design/icons';
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import './reviewWPAFormDetail.css'
import { ContextHandler } from '../../public/js/contextHandler';
import { studentCheckLogin } from '../newMain/studentMain';
import  trans  from './translation';
import MessagesTop from '../../component/messagesTop/messagesTop';
import moment from 'moment';//日期格式化导包
const { TextArea } = Input;
const ReviewWPAFormDetail = (props) => {
    
    const wpaApplId = localStorage.getItem(Config.tokenPrefix + 'wpaApplId');
    const history = useHistory();

    const [tables, setTables] = useState([]);
    const [tables2, setTables2] = useState([]);
    const [language, setLanguage] = useState("EN");
    const messageTopRef = useRef();
    const messageTopRefComment = useRef();
    const messageTopRefAsComment = useRef();

    const [isLoad, setIsLoad] = useState(false);
    const [form] = Form.useForm();
    const [isFromDate, setIsFromDate] = useState(false);
    const [isToDate, setIsToDate] = useState(false);
    const [wpaApplModel, setWpaApplModel] = useState({});
    const [wpaQuestionModel, setWpaQuestionModel] = useState({});

    useEffect(() => {
        initTable("EN")
        if (!Config.studentInfo?.studentId) {
            studentCheckLogin();
        }
        searchWpaQuestion();
        searchById();
    }, []);

    const initTable = () => {
        setTables2([
            {
                "id": 5,
                "score": 5,
                "performance": `${trans.completeWPAFormPart2_A_Excellent[language]}`,
                "descriptor": `${trans.completeWPAFormPart2_A_Excellent_desc[language]}`
            },
            {
                "id": 4,
                "score": 4,
                "performance": `${trans.completeWPAFormPart2_A_Good[language]}`,
                "descriptor": `${trans.completeWPAFormPart2_A_Good_desc[language]}`
            },
            {
                "id": 3,
                "score": 3,
                "performance": `${trans.completeWPAFormPart2_A_Satisfactory[language]}`,
                "descriptor": `${trans.completeWPAFormPart2_A_Satisfactory_desc[language]}`
            },
            {
                "id": 2,
                "score": 2,
                "performance": `${trans.completeWPAFormPart2_A_Acceptable[language]}`,
                "descriptor": `${trans.completeWPAFormPart2_A_Acceptable_desc[language]}`
            },
            {
                "id": 1,
                "score": 1,
                "performance": `${trans.completeWPAFormPart2_A_Unsatisfactory[language]}`,
                "descriptor": `${trans.completeWPAFormPart2_A_Unsatisfactory_desc[language]}`
            },
            {
                "id": 0,
                "score": 0,
                "performance": `${trans.completeWPAFormPart2_A_Unacceptable[language]}`,
                "descriptor": `${trans.completeWPAFormPart2_A_Unacceptable_desc[language]}`
            }
        ]);
    }

    const searchById = () => {
        let model = {
            wpaApplId : wpaApplId
        };
        Base.callBackApi("wpaAppl/searchById", model).then((data) => {
            if ("SUCCESS" === data?.msg) {
                let model = data?.object ?? {};
                setWpaApplModel(model);
                initForm(model);
            } else {
                console.log(data?.msg)
            }
        })
    }

    const searchWpaQuestion = () => {
        let model = {wpaApplId: wpaApplId};
        Base.callBackApi("wpaAppl/searchWpaQuestion", model).then((data) => {
            if ("SUCCESS" === data?.msg) {
                let model = data.object ?? {};
                setWpaQuestionModel(model);
                let list = [];
                for(let i = 1; i <= 8; i++) {
                    if(model['wpaQuestion' + i]) {
                        list.push({
                            id: 'wpaQuestionResult' + i,
                            question: model['wpaQuestion' + i],
                        })
                    }
                }
                for(let i = 9; i <= 13; i++) {
                    if(model['programmeSpecificWpaQuestion' + i]) {
                        list.push({
                            id: 'wpaQuestionResult' + i,
                            question: model['programmeSpecificWpaQuestion' + i],
                        })
                    }
                }
                setTables(list);
            } else {
                console.log(data?.msg)
            }
        })
    }

    const initForm = (model = {}) => {
        form.resetFields();
        form.setFieldsValue({
            wilHours: model.wilHours ?? "",
            periodStartDate: model?.periodStartDate ? moment(model?.periodStartDate) : null,
            periodEndDate: model?.periodEndDate ? moment(model?.periodEndDate) : null,
            companyName: model?.companyName ?? '',
            companyAddress: model?.companyAddress ?? '',
            industrySupervisorName: model?.industrySupervisorName ?? '',
            industrySupervisorPosition: model?.industrySupervisorPosition ?? '',
            industrySupervisorPhone: model?.industrySupervisorPhone ?? '',
            industrySupervisorEmail: model?.industrySupervisorEmail ?? '',
            wilHoursIs: model.wilHoursIs ?? "",
            periodStartDateIs: model?.periodStartDateIs ? moment(model?.periodStartDateIs) : null,
            periodEndDateIs: model?.periodEndDateIs ? moment(model?.periodEndDateIs) : null,
            companyNameIs: model?.companyNameIs ?? '',
            companyAddressIs: model?.companyAddressIs ?? '',
            industrySupervisorNameIs: model?.industrySupervisorNameIs ?? '',
            industrySupervisorPositionIs: model?.industrySupervisorPositionIs ?? '',
            industrySupervisorPhoneIs: model?.industrySupervisorPhoneIs ?? '',
            industrySupervisorEmailIs: model?.industrySupervisorEmailIs ?? '',
            activity1: model?.activity1 ?? '',
            activity2: model?.activity2 ?? '',
            activity3: model?.activity3 ?? '',
            activityProportion1: model?.activityProportion1 ?? '',
            activityProportion2: model?.activityProportion2 ?? '',
            activityProportion3: model?.activityProportion3 ?? '',
            wpaQuestionResult1: model?.wpaQuestionResult1 ?? '',
            wpaQuestionResult2: model?.wpaQuestionResult2 ?? '',
            wpaQuestionResult3: model?.wpaQuestionResult3 ?? '',
            wpaQuestionResult4: model?.wpaQuestionResult4 ?? '',
            wpaQuestionResult5: model?.wpaQuestionResult5 ?? '',
            wpaQuestionResult6: model?.wpaQuestionResult6 ?? '',
            wpaQuestionResult7: model?.wpaQuestionResult7 ?? '',
            wpaQuestionResult8: model?.wpaQuestionResult8 ?? '',
            wpaQuestionResult9: model?.wpaQuestionResult9 ?? '',
            wpaQuestionResult10: model?.wpaQuestionResult10 ?? '',
            wpaQuestionResult11: model?.wpaQuestionResult11 ?? '',
            wpaQuestionResult12: model?.wpaQuestionResult12 ?? '',
            wpaQuestionResult13: model?.wpaQuestionResult13 ?? '',
            workPerformance: model?.workPerformance ?? '',
            strengthArea: model?.strengthArea ?? '',
            growthArea: model?.growthArea ?? '',
            workPerformanceComment: model?.workPerformanceComment ?? '',
            signature: model?.signature ?? '',
            signatureDate: model?.signatureDate ? moment(model?.signatureDate) : null,
        });
        
        if(model?.wpaStatus == 'RETURNED_TO_STUDENT' && model?.eventRemark) {
            messageTopRef.current.setContent('Returned to Student Reason: ' + model?.eventRemark);
            messageTopRef.current.setIsShow(true);
        }
        if(model?.comments) {
            messageTopRefComment.current.setContent('From Assigned-AS: ' + model?.comments);
            messageTopRefComment.current.setIsShow(true);
        }
    }

    const checkStartDate = (value) => {
        if (Base.isEmpty(value)) {
            return Promise.reject("Expected Commence Date is required.");
        }
        if (Base.isNotEmpty(value)) {
            const endDate = form.getFieldValue('expEndDate')
            if (Base.isNotEmpty(endDate)) {
                if (Base.afterDate(value, endDate)) {
                    if (!isToDate) {
                        setIsToDate(true);
                        form.validateFields(["expEndDate"]);
                    }
                    return Promise.reject("Expected Commence Date cannot be later than Expected End Date. ")
                }
            }
        }
        if (isToDate) {
            form.validateFields(["expEndDate"]);
        }
        setIsToDate(false);
        return Promise.resolve();
    }

    const checkEndDate = (value) => {
        if (Base.isEmpty(value)) {
            return Promise.reject("Expected End Date is required.");
        }
        if (Base.isNotEmpty(value)) {
            const startDate = form.getFieldValue('expCommenceDate')
            if (Base.isNotEmpty(startDate)) {
                if (Base.afterDate(startDate, value)) {
                    if (!isFromDate) {
                        setIsFromDate(true);
                        form.validateFields(["expCommenceDate"]);
                    }
                    return Promise.reject("Expected End Date cannot be earlier than Expected Commence Date.")
                }
            }
        }
        if (isFromDate) {
            form.validateFields(["expCommenceDate"]);
        }
        setIsFromDate(false);
        return Promise.resolve();
    }

    const checkTimeSpent = (value) => {
        if (Base.isEmpty(value)) {
            return Promise.reject("Time Spent is required.");
        }
        if (value < 0) {
            return Promise.reject("Time Spent cannot be less than 0.");
        }
        const values = form.getFieldsValue();
        const { timeSpentOne, timeSpentTwo, timeSpentThree } = values;
        const total = Number(timeSpentOne ?? 0) + Number(timeSpentTwo ?? 0) + Number(timeSpentThree ?? 0);
        if (total != 100) {
            form.setFields([
                {
                    name: 'timeSpentOne',
                    errors: ['The sum of time spent must be equal to 100.'],
                },
                {
                    name: 'timeSpentTwo',
                    errors: ['The sum of time spent must be equal to 100.'],
                },
                {
                    name: 'timeSpentThree',
                    errors: ['The sum of time spent must be equal to 100.'],
                },
            ]);
        } else {
            form.setFields([
                {
                    name: 'timeSpentOne',
                    errors: [],
                },
                {
                    name: 'timeSpentTwo',
                    errors: [],
                },
                {
                    name: 'timeSpentThree',
                    errors: [],
                },
            ]);
        }
        // return Promise.resolve();
    }

    const columns = [
        {
            title: '',
            dataIndex: 'question',
            render: text => <div className='mustFill'>{text}</div>
        },
        {
            // title: '\xa05\xa0\xa0\xa0\xa0\xa04 \xa0\xa0\xa03\xa0\xa0\xa0\xa0\xa02\xa0\xa0\xa0\xa01\xa0\xa0\xa0\xa0 0',
            title: <div className='tableTitleFlexBox '>
                    <div>
                        <div>5</div>
                        <div className='tableSmallTitle'>Excellent</div>
                    </div>
                    <div>
                        <div>4</div>
                        <div className='tableSmallTitle'>Good</div>
                    </div>
                    <div>
                        <div>3</div>
                        <div className='tableSmallTitle'>Satisfactory</div>
                    </div>
                    <div>
                        <div>2</div>
                        <div className='tableSmallTitle'>Acceptable</div>
                    </div>
                    <div>
                        <div>1</div>
                        <div className='tableSmallTitle'>Unsatisfactory</div>
                    </div>
                    <div>
                        <div>0</div>
                        <div className='tableSmallTitle'>Unacceptable</div>
                    </div>
                </div>,
            dataIndex: 'id',
            width: 496,
            render: text => (
                <Form.Item
                    name={text}
                    rules={[
                        { required: true, message: "This is required." },
                    ]}
                >
                    <Radio.Group name="radiogroup" className='radioBox' disabled>
                        <Radio value={5}></Radio>
                        <Radio value={4}></Radio>
                        <Radio value={3}></Radio>
                        <Radio value={2}></Radio>
                        <Radio value={1}></Radio>
                        <Radio value={0}></Radio>
                    </Radio.Group>
                </Form.Item>
            ),
        },
    ];

    const columns2 = [
        {
            title: `${trans.completeWPAFormScore[language]}`,
            dataIndex: 'score',
            width: 120,
        },
        {
            title: `${trans.completeWPAFormPerformance[language]}`,
            dataIndex: 'performance',
            width: 360,
        },
        {
            title: `${trans.completeWPAFormDescriptor[language]}`,
            dataIndex: 'descriptor',
            className: 'tableTextLeftBox'
        },
    ];

    const onFinish = () => {

    }

    const generatePdf = () => {
        if (isLoad) {
            return;
        }
        setIsLoad(true);
        let model = wpaApplModel;
        fetch(Config.apiDownloadServer + "studentWPAFormPdf/generatePdf", {
            method: 'POST',
            body: JSON.stringify(model),
            headers: Config.header,
            mode: 'cors',
            cache: 'default'
        }).then(res => res.blob()).then(blob => {
            if (blob.type == "application/json") {
                var reader = new FileReader();
                reader.onload = e => {
                    var data = JSON.parse(e.target.result);
                    console.log(data);
                    // errFrameShow("error", data.msg);
                }
                reader.readAsText(blob);
            } else {
                var filename = "WPAForm" + moment(new Date()).format(Config.dateFormat3) + Base.generateFourDigitRandomNumber() + ".pdf";
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {// for IE
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else {// for Non-IE (chrome, firefox etc.)
                    var a = document.createElement('a');
                    document.body.appendChild(a);
                    a.style = 'display: none';
                    var url = window.URL.createObjectURL(blob);
                    a.href = url;
                    a.download = filename;
                    a.click();
                    a.remove();
                    window.URL.revokeObjectURL(url);
                }
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    return (
        <div id="container" className='websiteTemplate reviewWPAFormDetail'>
            <Spin size="large" spinning={isLoad} >
                <div className='websiteSysButtonRow'>
                    <div className='detailStatusBox'>
                        <div className='detailTitle'>Review WPA Form</div>
                        <div className={'statusTitleBox ' + wpaApplModel?.wpaStatus} >{ContextHandler.getMapValue('wpaFormStatusMap', wpaApplModel?.wpaStatus)}</div>
                    </div>
                    <div className="websiteSysButtonBox">
                        {
                            (wpaApplModel?.wpaStatus === 'ACCEPTED' || wpaApplModel?.wpaStatus === 'ACCEPTED_OFFLINE') &&
                            <Button className="websiteSysButton printButton" icon={<PrinterOutlined style={{ fontSize: "18px" }} />} onClick={() => generatePdf()}>Print WPA Form</Button>
                        }
                    </div>
                </div>
                <MessagesTop ref={messageTopRef} />
                <MessagesTop ref={messageTopRefComment} />
                <MessagesTop ref={messageTopRefAsComment} />
                <div className=''>
                    <Form form={form} onFinish={onFinish}>
                    {(wpaApplModel?.wpaStatus == 'PENDING_REVIEW' || wpaApplModel?.wpaStatus == 'REJECTED' || wpaApplModel?.wpaStatus == 'ACCEPTED' || wpaApplModel?.wpaStatus == 'ACCEPTED_OFFLINE' || wpaApplModel?.wpaStatus == 'TERMINATED') && wpaApplModel?.wpaDisplayFlag == 'Y' &&
                        <div className='websiteSysContentBox'>
                            <div className='detailTitle contentTitle'>
                                WIL - Student Work Performance Appriaisal
                            </div>
                            <div className='flexBox'>
                                <div className='value valueJustify boxWidMax'>
                                Thank you for participating in the Student Work Integrated Learning of THEi’s Programme. We hope your experience is rewarding.
                                </div>
                                <div className='value valueJustify boxWidMax'>
                                Your evaluation of the student’s performance will contribute a significant part to the student’s overall grade in the WIL credit-bearing module. Please be as candid as possible. All information provided is kept confidential and for academic use only.
                                </div>
                            </div>

                            <div className='contentTitle'>
                            Attention
                            </div>
                            <div className='flexBox'>
                                <div className='value valueJustify boxWidMax'>
                                    {trans.completeWPAFormAttention1[language]}
                                </div>
                                <div className='value valueJustify boxWidMax'>
                                    {trans.completeWPAFormAttention2[language]}
                                </div>
                                <div className='value valueJustify boxWidMax'>
                                    {trans.completeWPAFormAttention3[language]}
                                </div>
                                <div className='value valueJustify boxWidMax'>
                                    {trans.completeWPAFormAttention4[language]}
                                </div>
                                <div className='value valueJustify boxWidMax'>
                                    {trans.completeWPAFormAttention5[language]}
                                </div>
                            </div>
                            <div className="sysTable" id="tableOne">
                                <div className='contentTitle centerBox'>
                                    {trans.completeWPAFormRatingScale[language]}
                                </div>
                                <Table
                                    scroll={{ x: 700 }}
                                    rowKey="id"
                                    columns={columns2} //列名
                                    dataSource={tables2} //数据
                                    pagination={false}
                                />
                            </div>
                        </div>
                    }
                    <div className='websiteSysContentBox'>
                        <div className='contentTitle'>
                            Part I – Information of Student & WIL Partner
                        </div>
                        <div className='contentTitle'>
                            Student Information
                        </div>
                        <div className="websiteSysRow">
                            <div className="websiteSysCol">
                                <div className="websiteSysParam ">Student Name</div>
                                <div className="websiteSysInput">
                                    <Input className="input" type="text" placeholder="Student Name" value={wpaApplModel?.firstName + ' ' + wpaApplModel?.lastName} disabled />
                                </div>
                            </div>
                            <div className="websiteSysCol">
                                <div className="websiteSysParam ">Student ID</div>
                                <div className="websiteSysInput">
                                    <Input className="input" type="text" placeholder="Student ID" value={wpaApplModel?.studentAcctId} disabled />
                                </div>
                            </div>
                        </div>
                        <div className="websiteSysRow">
                            <div className="websiteSysCol">
                                <div className="websiteSysParam ">Programme Name</div>
                                <div className="websiteSysInput">
                                    <Input className="input" type="text" placeholder="Programme Title" value={wpaApplModel?.progTitle} disabled />
                                </div>
                            </div>
                            <div className="websiteSysCol">
                                <div className="websiteSysParam ">WIL Module Code</div>
                                <div className="websiteSysInput">
                                    <Input className="input" type="text" placeholder="WIL Module Code" value={wpaApplModel?.moduleCode} disabled />
                                </div>
                            </div>
                        </div>
                        <div className="websiteSysRow">
                            <div className="websiteSysCol">
                                <div className="websiteSysParam ">WIL Module Title</div>
                                <div className="websiteSysInput">
                                    <Input className="input" type="text" placeholder="WIL Module Title" value={wpaApplModel?.moduleName} disabled />
                                </div>
                            </div>
                            <div className="websiteSysCol">
                                <div className="websiteSysParam mustFill">Total WIL Hours</div>
                                <div className="websiteSysInput">
                                    <Form.Item
                                        name="wilHours"
                                        rules={[
                                            { required: true, message: 'Total WIL Hours is required.' },
                                        ]}
                                    >
                                        <InputNumber precision={1} maxLength={5} placeholder="Total WIL Hours" disabled />
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                        <div className="websiteSysRow">
                            <div className="websiteSysCol">
                                <div className="websiteSysParam mustFill">WIL Period</div>
                                <div className="websiteSysInput dateInput">
                                    <Form.Item
                                        name="periodStartDate"
                                        rules={[
                                            { required: true, validator: (rule, value) => checkStartDate(value) },
                                        ]}
                                    >
                                        <DatePicker placeholder="Start Date"
                                            className="parts-numberInput datePickerAllWidth"
                                            format={Config.dateFormatEn}
                                            getPopupContainer={(triggerNode) => triggerNode.parentNode} 
                                            disabled
                                            />
                                    </Form.Item>
                                    <div style={{ width: "10px" }}>-</div>
                                    <Form.Item
                                        name="periodEndDate"
                                        rules={[
                                            { required: true, validator: (rule, value) => checkEndDate(value) },
                                        ]}
                                    >
                                        <DatePicker placeholder="End Date"
                                            className="parts-numberInput datePickerAllWidth"
                                            format={Config.dateFormatEn}
                                            getPopupContainer={(triggerNode) => triggerNode.parentNode} 
                                            disabled
                                            />
                                    </Form.Item>
                                </div>
                            </div>
                            <div className="websiteSysCol"></div>
                        </div>
                        <div className='contentTitle'>
                            Host Company/ Organisation Information
                        </div>
                        <div className="websiteSysRow">
                            <div className="websiteSysCol">
                                <div className="websiteSysParam mustFill">Company/ Organisation Name</div>
                                <div className="websiteSysInput">
                                    <Form.Item
                                        name="companyName"
                                        rules={[
                                            { required: true, message: "Company/ Organisation Name is required." },
                                        ]}
                                    >
                                        <Input className="input" type="text" placeholder="Company/ Organisation Name" maxLength={100} disabled />
                                    </Form.Item>
                                </div>
                            </div>
                            <div className="websiteSysCol">
                                <div className="websiteSysParam mustFill">Company/ Organisation Address</div>
                                <div className="websiteSysInput">
                                    <Form.Item
                                        name="companyAddress"
                                        rules={[
                                            { required: true, message: "Company/ Organisation Address is required." },
                                        ]}
                                    >
                                        <Input className="input" type="text" placeholder="Company/ Organisation Address" maxLength={400} disabled />
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                        <div className='contentTitle'>
                            Industry Supervisor Information
                        </div>
                        <div className="websiteSysRow">
                            <div className="websiteSysCol">
                                <div className="websiteSysParam mustFill">Name</div>
                                <div className="websiteSysInput">
                                    <Form.Item
                                        name="industrySupervisorName"
                                        rules={[
                                            { required: true, message: "Name is required." },
                                        ]}
                                    >
                                        <Input className="input" type="text" placeholder="Name" maxLength={50} disabled />
                                    </Form.Item>
                                </div>
                            </div>
                            <div className="websiteSysCol">
                                <div className="websiteSysParam mustFill">Position</div>
                                <div className="websiteSysInput">
                                    <Form.Item
                                        name="industrySupervisorPosition"
                                        rules={[
                                            { required: true, message: "Position is required." },
                                        ]}
                                    >
                                        <Input className="input" type="text" placeholder="Position" maxLength={50} disabled />
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                        <div className="websiteSysRow">
                            <div className="websiteSysCol">
                                <div className="websiteSysParam mustFill">Telephone Number</div>
                                <div className="websiteSysInput">
                                    <Form.Item
                                        name="industrySupervisorPhone"
                                        rules={[
                                            { required: true, message: "Telephone Number is required." },
                                        ]}
                                    >
                                        <Input className="input" type="text" placeholder="Telephone Number" maxLength={12} disabled />
                                    </Form.Item>
                                </div>
                            </div>
                            <div className="websiteSysCol">
                                <div className="websiteSysParam mustFill">Email Address</div>
                                <div className="websiteSysInput">
                                    <Form.Item
                                        name="industrySupervisorEmail"
                                        rules={[
                                            { required: true, message: 'Email Address is required.' },
                                            { pattern: /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/, message: 'Incorrect Email format.' },
                                        ]}
                                    >
                                        <Input className="input" type="text" placeholder="Email Address" maxLength={50} disabled />
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                        </div>
                        
                        {(wpaApplModel?.wpaStatus == 'PENDING_REVIEW' || wpaApplModel?.wpaStatus == 'REJECTED' || wpaApplModel?.wpaStatus == 'ACCEPTED' || wpaApplModel?.wpaStatus == 'ACCEPTED_OFFLINE' || wpaApplModel?.wpaStatus == 'TERMINATED') && wpaApplModel?.wpaDisplayFlag == 'Y' &&
                            <div className='websiteSysContentBox'>
                                <div className="contentTitle">{"Part II – Assessment of Student"}</div>
                                <div className="contentTitle marginBottom15">SECTION A - MAJOR WIL ACTIVITIES</div>
                                <div className='flexBox'>
                                    <div className='value valueJustify'>Please outline the three major WIL activities in which the student was exposed to during the their WIL at in your organisation.</div>
                                </div>
                                <div className='websiteSysButtonRow'>
                                    <div className='detailStatusBox'>
                                        <div className='contentTitle2'>Activity</div>
                                    </div>
                                    <div className='websiteSysButtonBox'>
                                        <div className='contentTitle2' >% Proportion of Time Spent</div>
                                    </div>
                                </div>
                                <div className='websiteSysRow'>
                                    <div className='websiteSysCol'>
                                        <div className='label '>1</div>
                                        <div className="websiteSysInput">
                                            <Form.Item
                                                name="activity1"
                                                rules={[
                                                    { required: true, message: "Activity 1 is required." },
                                                ]}
                                            >
                                                <Input className="input" type="text"  maxLength={400} disabled />
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='websiteSysColMin'>
                                        <div className="websiteSysInput">
                                            <Form.Item
                                                name="activityProportion1"
                                                rules={[
                                                    { required: true, validator: (rule, value) => checkTimeSpent(value) },
                                                ]}
                                            >
                                                <InputNumber className="input" type="text" maxLength={8} precision={2} addonAfter={"%"} disabled />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='websiteSysRow'>
                                    <div className='websiteSysCol'>
                                        <div className='label '>2</div>
                                        <div className="websiteSysInput">
                                            <Form.Item
                                                name="activity2"
                                                rules={[
                                                    { required: true, message: "Activity 2 is required." },
                                                ]}
                                            >
                                                <Input className="input" type="text"  maxLength={400} disabled />
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='websiteSysColMin'>
                                        <div className="websiteSysInput">
                                            <Form.Item
                                                name="activityProportion2"
                                                rules={[
                                                    { required: true, validator: (rule, value) => checkTimeSpent(value) },
                                                ]}
                                            >
                                                <InputNumber className="input" type="text" maxLength={8} precision={2} addonAfter={"%"} disabled />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='websiteSysRow'>
                                    <div className='websiteSysCol'>
                                        <div className='label '>3</div>
                                        <div className="websiteSysInput">
                                            <Form.Item
                                                name="activity3"
                                                rules={[
                                                    { required: true, message: "Activity 3 is required." },
                                                ]}
                                            >
                                                <Input className="input" type="text"  maxLength={400} disabled />
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='websiteSysColMin'>
                                        <div className="websiteSysInput">
                                            <Form.Item
                                                name="activityProportion3"
                                                rules={[
                                                    { required: true, validator: (rule, value) => checkTimeSpent(value) },
                                                ]}
                                            >
                                                <InputNumber className="input" type="text" maxLength={8} precision={2} addonAfter={"%"} disabled />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='flexBox'>
                                    <div className='websiteSysCol'></div>
                                    <div className='websiteSysColMin flexBox'>
                                        <div className='label'></div>
                                        <div className="value">
                                            The sum should be 100%.
                                        </div>
                                    </div>
                                </div>
                                <div className="contentTitle marginBottom15 labelCircleBox">
                                    SECTION B - ASSESSMENT OF STUDENT COMPETENCIES
                                    <Popover placement="right" content={<div style={{ maxWidth: "500px", textAlign: 'justify' }}>
                                        {wpaQuestionModel?.IBoxContent}
                                    </div>} trigger="hover">
                                        <div className='labelCircle'><InfoCircleOutlined /></div>
                                    </Popover>
                                </div>
                                <div className="sysTable completeWPAForm2 marginBottom15" id="tableOne">
                                    <Table
                                        scroll={{ x: 500 }}
                                        rowKey="id"
                                        columns={columns} //列名
                                        dataSource={tables} //数据
                                        pagination={false}
                                    />
                                </div>
                                <div className="contentTitle sectionTitleMax">SECTION C - WORK PERFORMANCE AND COMMENTS</div>
                                <div className='flexBox sectionTitle'>
                                    <div className='value valueJustify mustFill'>Please rate the student’s overall work performance in consideration of the quality of work, job timeliness, and understanding of work requirements.</div>
                                </div>
                                <div className="checkbox">
                                    <Form.Item
                                        name="workPerformance"
                                        rules={[
                                            { required: true, message: trans.completeWPAFormPart2_C_Desc[language] },
                                        ]}
                                    >
                                        <Radio.Group
                                            options={[
                                                {
                                                    label: 'Excellent (5)',
                                                    value: 5,
                                                },
                                                {
                                                    label: 'Good (4)',
                                                    value: 4,
                                                },
                                                {
                                                    label: 'Satisfactory (3)',
                                                    value: 3,
                                                },
                                                {
                                                    label: 'Acceptable (2)',
                                                    value: 2,
                                                },
                                                {
                                                    label: 'Unsatisfactory (1)',
                                                    value: 1,
                                                },
                                                {
                                                    label: 'Unacceptable (0)',
                                                    value: 0,
                                                },
                                            ]}
                                            disabled
                                        />
                                    </Form.Item>
                                </div>
                                <div className='flexBox margin20'>
                                    <div className="value valueJustify">Please give comments on the student’s area(s) of strength and Growth.</div>
                                </div>
                                <div className="websiteSysCol margin20">
                                    <div className="websiteSysParam150 label">Areas of Strength</div>
                                    <div className="websiteSysInputMax">
                                        <Form.Item
                                            name="strengthArea"
                                        >
                                            <TextArea maxLength={1000} rows={3} placeholder="" disabled />
                                        </Form.Item>
                                    </div>
                                </div>
                                <div className="websiteSysCol margin20">
                                    <div className="websiteSysParam150 label">Areas of Growth</div>
                                    <div className="websiteSysInputMax">
                                        <Form.Item
                                            name="growthArea"
                                        >
                                            <TextArea maxLength={1000} rows={3} placeholder="" disabled />
                                        </Form.Item>
                                    </div>
                                </div>
                                <div className='flexBox margin20'>
                                    <div className="value valueJustify">Please give your comments on the student’s performance and attributes as assessed above and other related matters.</div>
                                </div>
                                <div className="flexBox margin20">
                                    <div className="websiteSysInputMax">
                                        <Form.Item
                                            name="workPerformanceComment"
                                        >
                                            <TextArea maxLength={1000} rows={3} placeholder="" disabled />
                                        </Form.Item>
                                    </div>
                                </div>
                                <div className="websiteSysRow">
                                    <div className="websiteSysCol">
                                        <div className="websiteSysParamMin mustFill label2">Name of Industry Supervisor</div>
                                        <div className="websiteSysInput websiteSysInputMin">
                                            <Form.Item
                                                name="signature"
                                                rules={[
                                                    { required: true, message: "Name of Industry Supervisor is required." },
                                                ]}
                                            >
                                                <Input className="input" type="text" placeholder="Name of Industry Supervisor" maxLength={50} disabled />
                                            </Form.Item>
                                        </div>
                                        <div className="websiteSysParamMin2 mustFill label2">Date</div>
                                        <div className="websiteSysInput websiteSysInputMin">
                                            <Form.Item
                                                name="signatureDate"
                                            >
                                                <DatePicker placeholder="Date"
                                                    className="parts-numberInput datePickerAllWidth"
                                                    format={Config.dateFormatEn}
                                                    getPopupContainer={(triggerNode) => triggerNode.parentNode} disabled />
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className="websiteSysCol">
                                        <div className="label mustFill">Signature of Industry Supervisor with Company Stamp</div>
                                        <div className="websiteSysInput">
                                            <div className="signImgBox">
                                                {wpaApplModel?.signatureImgPath && <img src={Config.wpaApplImg + wpaApplModel?.signatureImgPath + '?' + Config.sasToken}></img>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </Form>
                </div>
                <div className="websiteSysButtonBox">
                    {
                        (wpaApplModel?.wpaStatus === 'ACCEPTED' || wpaApplModel?.wpaStatus === 'ACCEPTED_OFFLINE') && wpaApplModel?.wpaDisplayFlag == 'Y' &&
                        <Button className="websiteSysButton printButton" icon={<PrinterOutlined style={{ fontSize: "18px" }} />} onClick={() => generatePdf()}>Print WPA Form</Button>
                    }
                </div>
            </Spin>
        </div>
    )

}

export default ReviewWPAFormDetail;